import { AccountCircle } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Card,
  ClickAwayListener,
  CssBaseline,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  MenuList,
  Popper,
  Select,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  baseFeatureFilesReset,
  baseFeatureFilesUpdate,
} from "src/redux/slices/baseFilesSlice";
import {
  clientDetailsReset,
  getClientDetails,
} from "src/redux/slices/clientDetailsSlice";
import {
  userFilesReset,
  userFilesUpdate,
} from "src/redux/slices/userFilesSlice";
import { Products } from "src/types/ClientDetails";
import { checkSubscription } from "src/utils/CommonUtil";
import rs_logo from "../../assets/redshift-logo-final.svg";
import { setContainerIdnull } from "../../redux/slices/dockercontid";
import { login, logout, selectUser } from "../../redux/slices/userSlice";
import { PRODUCTSLIST } from "../constants/Constants";
import WarningPopup from "../modal/WarningPopup";
import navbarstyles from "./Navbar.module.css";

const AppHeader = () => {
  const [accountOpen, setAccountOpen] = useState(false); // State to control popper visibility
  const [anchorEl2, setAnchorEl2] = useState<null | HTMLElement>(null);
  const [isPopUpOpened, setIsPopUpOpened] = useState<boolean>(false);
  const user = useSelector(selectUser);
  const clients = useSelector(getClientDetails);
  const [productcode, setproductcode] = useState(user?.productCode);
  const [selectedClient, setSelectedClient] = useState(user?.selectedClient);
  const [clientPopup, setClientPopup] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAccountClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAccountOpen((prevOpen) => !prevOpen); // Toggle the popper visibility
    setAnchorEl2(event.currentTarget); // Store the anchor element
  };

  const handleChangePassword = () => {
    navigate("/changePassword");
    setAccountOpen(false);
  };

  const handlePopupCancel = () => {
    setIsPopUpOpened(false);
  };

  const handleSignOut = () => {
    setproductcode(undefined);
    dispatch(baseFeatureFilesReset());
    dispatch(userFilesReset());
    dispatch(logout());
    dispatch(setContainerIdnull());
    dispatch(clientDetailsReset());
    navigate("/login");
    setAccountOpen(false);
  };

  const handleClickAway = () => {
    setAccountOpen(false);
  };

  const handleDropDownChange = (e: any) => {
    const { name, value } = e.target;
    if (user.role === "SYSTEM_ADMIN" || user.role === "SYSTEM_USER") {
      if (
        checkSubscription(
          clients,
          name === "clientCode" ? value : user.selectedClient,
          name === "productCode" ? value : user.productCode
        )
      ) {
        if (name === "clientCode") {
          setSelectedClient(value);
        } else {
          setproductcode(value);
        }
        dispatch(
          login({
            userDetailsId: user.userDetailsId,
            userId: user.userId,
            password: user.password,
            email: user.email,
            role: user.role,
            permissionsList: user.permissionsList,
            productCode: name === "productCode" ? value : user.productCode,
            firstName: user.firstName,
            lastName: user.lastName,
            products: user.products,
            filesStatus: false,
            clientId: user.clientId,
            clientCode: user.clientCode,
            selectedClient: name === "clientCode" ? value : user.selectedClient,
            auth: user.auth,
          })
        );
        dispatch(
          baseFeatureFilesUpdate({
            baseFiles: undefined,
          })
        );
        dispatch(userFilesUpdate({ userFiles: undefined }));
      } else {
        if (name === "clientCode") {
          setSelectedClient(value);
        } else {
          setproductcode(value);
        }
        setClientPopup(true);
      }
    } else {
      if (
        user.products.some(
          (product: Products) => product.productName.indexOf(value) !== -1
        )
      ) {
        setproductcode(value);
        dispatch(
          login({
            userDetailsId: user.userDetailsId,
            userId: user.userId,
            password: user.password,
            email: user.email,
            role: user.role,
            permissionsList: user.permissionsList,
            productCode: value,
            firstName: user.firstName,
            lastName: user.lastName,
            products: user.products,
            filesStatus: true,
            clientId: user.clientId,
            clientCode: user.clientCode,
            selectedClient: user.selectedClient,
            auth: user.auth,
          })
        );
        dispatch(
          baseFeatureFilesUpdate({
            baseFiles: undefined,
          })
        );
        dispatch(userFilesUpdate({ userFiles: undefined }));
      } else {
        setIsPopUpOpened(true);
      }
    }
  };

  const handleOkay = () => {
    dispatch(
      login({
        userDetailsId: user.userDetailsId,
        userId: user.userId,
        password: user.password,
        email: user.email,
        role: user.role,
        permissionsList: user.permissionsList,
        productCode: productcode ? productcode : user.productCode,
        firstName: user.firstName,
        lastName: user.lastName,
        products: user.products,
        filesStatus: false,
        clientId: user.clientId,
        clientCode: user.clientCode,
        selectedClient: selectedClient ? selectedClient : user.selectedClient,
        auth: user.auth,
      })
    );
    setClientPopup(false);
  };

  const handleSelectCode = (event: any) => {
    let { value, name } = event.target;
    if (name === "productCode") {
      setproductcode(value);
    } else {
      setSelectedClient(value);
    }
  };

  return (
    <>
      <AppBar
        position="sticky"
        className={navbarstyles.appbarCss}
      >
        <Toolbar variant="dense">
          <Box className={navbarstyles.toolbarOuterBox}>
            <Box className={navbarstyles.toolbarInnerBox}>
              <Typography
                variant="h6"
                onClick={() => navigate("/")}
                sx={{ cursor: "pointer" }}
              >
                RS Automator
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 4,
              }}
            >
              {user &&
                (user.role === "SYSTEM_ADMIN" ||
                  user.role === "SYSTEM_USER") && (
                  <FormControl
                    sx={{
                      width: "fit-content",
                    }}
                  >
                    <Select
                      required
                      size="small"
                      id="clientCode"
                      name="clientCode"
                      value={
                        user.selectedClient
                          ? user.selectedClient
                          : user.clientCode
                      }
                      onChange={(e) => {
                        handleDropDownChange(e);
                      }}
                      defaultValue={user.selectedClient}
                      disabled={user.filesStatus === true}
                    >
                      {clients?.map((client: any) => (
                        <MenuItem
                          key={client.clientCode}
                          value={client.clientCode}
                        >
                          {client.clientCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              {user && (
                <FormControl
                  sx={{
                    width: "fit-content",
                  }}
                >
                  <Select
                    required
                    size="small"
                    id="statuscode"
                    name="productCode"
                    value={user.productCode}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      "& .MuiSelect-root": {
                        alignSelf: "flex-start",
                      },
                    }}
                    onChange={(e) => {
                      handleDropDownChange(e);
                    }}
                    defaultValue={user.productCode}
                    disabled={user.filesStatus === true}
                  >
                    {PRODUCTSLIST.map((product) => (
                      <MenuItem
                        key={product.productId}
                        value={product.productName}
                      >
                        {product.productName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <Box className={navbarstyles.navbarImageOuterBox}>
                <Typography
                  variant="h5"
                  component="div"
                >
                  <img
                    className={navbarstyles.rsLogoCss}
                    src={rs_logo}
                    alt="logo"
                  />
                </Typography>
                {user && (
                  <IconButton
                    edge="start"
                    onClick={handleAccountClick}
                    disableRipple={true}
                  >
                    <AccountCircle className={navbarstyles.accountCircleCss} />
                  </IconButton>
                )}
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <CssBaseline />
      {user && (
        <Popper
          open={accountOpen}
          anchorEl={anchorEl2}
        >
          <ClickAwayListener onClickAway={handleClickAway}>
            <Card className={navbarstyles.popperCardCss}>
              <MenuList
                autoFocusItem={accountOpen}
                id="account-menu-list"
              >
                <MenuItem
                  onClick={handleClickAway}
                  dense
                  className={navbarstyles.popperMenuItemCss}
                >
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                  >
                    <Box
                      display={"flex"}
                      gap={1}
                      alignItems={"center"}
                      textOverflow={"ellipsis"}
                      overflow={"hidden"}
                    >
                      <AccountCircle />
                      <Tooltip
                        placement="top-start"
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -10],
                                },
                              },
                            ],
                          },
                        }}
                        title={`${user.firstName} ${user.lastName}`}
                      >
                        <Box
                          textOverflow={"ellipsis"}
                          overflow={"hidden"}
                          width={"10em"}
                          whiteSpace={"nowrap"}
                        >
                          {user.firstName} {user.lastName}
                        </Box>
                      </Tooltip>
                    </Box>

                    <Box
                      display={"flex"}
                      ml={4}
                    >
                      ({user.userId})
                    </Box>
                  </Box>
                </MenuItem>
                <Divider className={navbarstyles.popperDividerCss} />
                <MenuItem
                  onClick={handleChangePassword}
                  dense
                  className="card"
                >
                  Change Password
                </MenuItem>
                <Divider className={navbarstyles.popperDividerCss} />
                <MenuItem
                  onClick={handleSignOut}
                  dense
                  className="card"
                  disabled={user.filesStatus === true}
                >
                  Sign Out
                </MenuItem>
              </MenuList>
            </Card>
          </ClickAwayListener>
        </Popper>
      )}
      {isPopUpOpened && (
        <WarningPopup
          isOpen={true}
          onClose={handlePopupCancel}
          actionButtons={[
            {
              name: "Close",
              onButtonClick: handlePopupCancel,
            },
          ]}
        >
          <Typography>
            You don't have enough privileges. Please contact your administrator.
          </Typography>
        </WarningPopup>
      )}
      {clientPopup && (
        <WarningPopup
          isOpen={true}
          actionButtons={[
            {
              name: "Ok",
              onButtonClick: handleOkay,
              isDisabled: !checkSubscription(
                clients,
                selectedClient ? selectedClient : user.selectedClient,
                productcode ? productcode : user.productCode
              ),
            },
          ]}
        >
          <Box sx={{ paddingBottom: "5%" }}>
            <Typography>Please select clientCode and productCode:</Typography>
          </Box>
          <Box sx={{ display: "inline" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <FormControl
                sx={{ width: "48%" }}
                size="small"
              >
                <InputLabel>ClientCodes</InputLabel>
                <Select
                  value={selectedClient ? selectedClient : user.selectedClient}
                  label="clientCode"
                  name="clientCode"
                  onChange={handleSelectCode}
                >
                  {clients?.map((client: any) => (
                    <MenuItem
                      key={client.clientCode}
                      value={client.clientCode}
                    >
                      <ListItemText primary={client.clientCode} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                sx={{ width: "48%" }}
                size="small"
              >
                <InputLabel>ProductCodes</InputLabel>
                <Select
                  value={productcode ? productcode : user.productCode}
                  label="productCode"
                  name="productCode"
                  onChange={handleSelectCode}
                >
                  {PRODUCTSLIST.map((product) => (
                    <MenuItem
                      key={product.productName}
                      value={product.productName}
                    >
                      <ListItemText primary={product.productName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            {!checkSubscription(
              clients,
              selectedClient ? selectedClient : user.selectedClient,
              productcode ? productcode : user.productCode
            ) && (
              <Typography
                variant="subtitle2"
                sx={{ color: "#fe524a", paddingTop: "2%" }}
              >
                Client is not subscribed to the selected product.
              </Typography>
            )}
          </Box>
        </WarningPopup>
      )}
    </>
  );
};

export default AppHeader;
